import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import AccountService from 'wanderu-service-account';
import { SnowplowService } from 'wanderu-service-analytics';

import { actions as userInfoActions } from '../../appstate/userInfo';
import { actions } from './base';

const logger = Logger.getLogger('wanderu-duck-account');

function reset(orderId) {
    return actions.reset(orderId);
}

function fetch(urlForPollingTicket, orderId, type) {
    return async (dispatch) => {
        dispatch(actions.startWork(orderId));

        let meta;
        let error;
        try {
            const downloadUrl = await AccountService.fetchTicketUrl(
                urlForPollingTicket,
                orderId,
                type,
            );

            return dispatch(userInfoActions.setTicketDownloadUrl({
                orderId,
                downloadUrl,
            }));
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetchTicketUrl', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(orderId, meta, error));
        }
    };
}

export {
    fetch,
    reset,
};
